<div class="viewport-warning">
  <div class="mb-0">
    <ng-lottie [options]="options()" width="170px" height="170px" />
  </div>
  <div class="max-w-[80%]">{{ 'viewport-warning.message' | transloco }}</div>
</div>
